/**
 * IP-15393 — shapes shared by the deactivation dialog and its parts.
 */
/**
 * The two non-technician choices. `LEAVE` is the default and a no-op; `UNASSIGN` is a sentinel
 * rather than a blank so "move it to nobody" is distinguishable from "the param was never sent".
 * Both are read by Settings::TechniciansController#reassignment_destination.
 */
export const LEAVE_AS_IS = '';
export const UNASSIGN = 'unassigned';
